import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UtilityService {
	private scrollAnnouncedSource = new Subject<void>();
	public scrollAnnounced$ = this.scrollAnnouncedSource.asObservable();

	constructor() {}

	announceScroll() {
		this.scrollAnnouncedSource.next();
	}
}
